import axios from "axios";
 
axios.defaults.baseURL = process.env.NODE_ENV === "development" ? "https://geminival.com/" : '';

export default axios;
